import script from "./LocalModelCacheTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalModelCacheTable.vue?vue&type=script&setup=true&lang=js"

import "./LocalModelCacheTable.vue?vue&type=style&index=0&id=3a54448e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a54448e"]])

export default __exports__